import * as React from 'react';

interface EventPageBackgroundProps {
  backgroundImageUrl?: string;
  backgroundColor?: string;
  className?: string;
  children: React.ReactNode;
}

/**
 * RSVP/event page shell. Decorative background uses a fixed layer instead of
 * background-attachment: fixed, which intercepts taps on iOS Safari.
 */
export function EventPageBackground({
  backgroundImageUrl,
  backgroundColor,
  className = 'flex min-h-screen flex-col',
  children,
}: EventPageBackgroundProps) {
  const solidStyle: React.CSSProperties | undefined =
    backgroundColor && !backgroundImageUrl ? { backgroundColor } : undefined;

  return (
    <div className={`relative ${className}`} style={solidStyle}>
      {backgroundImageUrl ? (
        <div
          className="pointer-events-none fixed inset-0 -z-10 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${backgroundImageUrl})` }}
          aria-hidden="true"
        />
      ) : null}
      {children}
    </div>
  );
}
